import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './highlight.css'

const Highlight = (props) => {
  return (
    <div className="highlight-highlight">
      <span className="highlight-text1">
        {props.text ?? (
          <Fragment>
            <span className="highlight-text4">
              Everything you get with Finbest
            </span>
          </Fragment>
        )}
      </span>
      <span className="highlight-text2">
        {props.text1 ?? (
          <Fragment>
            <span className="highlight-text3">
              Sed do eiusmod tempor incididunt ut labore et dolore magna aliquat
              enim ad minim veniam, quis nostrud
            </span>
          </Fragment>
        )}
      </span>
    </div>
  )
}

Highlight.defaultProps = {
  text1: undefined,
  text: undefined,
}

Highlight.propTypes = {
  text1: PropTypes.element,
  text: PropTypes.element,
}

export default Highlight
